import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 6h2v12H4V6zm3 0h1v12H7V6zm2 0h3v12H9V6zm4 0h1v12h-1V6zm3 0h2v12h-2V6zm3 0h1v12h-1V6zM2 4v4H0V4a2 2 0 012-2h4v2H2zm20-2a2 2 0 012 2v4h-2V4h-4V2h4zM2 16v4h4v2H2a2 2 0 01-2-2v-4h2zm20 4v-4h2v4a2 2 0 01-2 2h-4v-2h4z"
       fill="currentColor"
      />
    </svg>
  )
}

export default SvgComponent
